import { denormalize } from "normalizr";
import { factoringCompany } from "../../../api/schema";

export default id => state => {
  try {
    const denormalized = denormalize(
      { item: id },
      { item: factoringCompany },
      state.entities
    );

    return denormalized.item || {};
  } catch (err) {
    return {};
  }
};
